import { render, staticRenderFns } from "./saveFooter.vue?vue&type=template&id=467338f0"
import script from "./saveFooter.vue?vue&type=script&lang=js"
export * from "./saveFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467338f0')) {
      api.createRecord('467338f0', component.options)
    } else {
      api.reload('467338f0', component.options)
    }
    module.hot.accept("./saveFooter.vue?vue&type=template&id=467338f0", function () {
      api.rerender('467338f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/saveFooter.vue"
export default component.exports